import { render, staticRenderFns } from "./Folio.vue?vue&type=template&id=1fed4c6c"
import script from "./Folio.vue?vue&type=script&lang=js"
export * from "./Folio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports